'use strict';

import {
    addButtonStyling, addExpandableColumnListener, addFormControlSelect2, addTopSearchColumn,
    dtTooltipName
} from "../../jquery-functions-library";
import moment from "moment";
import {element_exists} from "../../functions";

export var fnDashV2AllTable = function () {

    var tableName = '#datatable-db-v2-all';

    if (!element_exists(tableName) || $.fn.dataTable.isDataTable(tableName)) return false;

    var companyGrouping = $('#company_grouping');
    companyGrouping.select2({width: '271px', height: '75%'}).addClass('form-control');
    addFormControlSelect2();

    companyGrouping.off('select2:select').on('select2:select', function (e) {
        var reportingPeriod = $('#reporting-period').val();
        var companyGroupingVal = $('#company_grouping').val();
        
        $(tableName).DataTable().ajax.url('/dashboard/admin/v2/all/' + reportingPeriod + '/' + companyGroupingVal).load();
    });

    var reportingPeriod = $('#reporting-period').val();
    var companyGroupingVal = $('#company_grouping').val();

    /**
     * Alignment,search, export columns etc important to test when adding here!
     */
    var columns = [
        {data: 'id'},
        dtTooltipName(),
        {data: 'employee_initials'},

        //Status
        {data: 'bookkeeping_status_column'},
        {data: 'bookkeeping_status'},
        {data: 'missing_docs_deadline'},
        {data: 'reporting_finished'},
        {data: 'reporting_status'},
        {data: 'report_deadline_column'},
        {data: 'vat_reported'},
        {data: 'vat_status'},

        //VAT
        {data: 'next_vat_deadline'},
        {data: 'accounting_year'},

        //Salary
        {data: 'salary_output'},
        //End Salary

        {data: 'vat_frequency_column'},
        //End VAT

        //Deadlines
        {data: 'daily_frequency'},
        {data: 'update_frequency'},
        //End deadlines

        //Metrics
        {data: 'postings'},
        {data: 'actual_vs_contract'},
        {data: 'active_services'},
        //End metrics

        //Vouchers
        {data: 'handled_vouchers'},
        //End vouchers
        {
            data: 'services.reload_on_demand', render: function (data, type, row) {
                let yesObj = {
                    color: 'btn-success',
                    value: 1,
                    text: allLangFiles.forms.yes_no[1]
                };
                let noObj = {
                    color: 'btn-warning',
                    value: 0,
                    text: allLangFiles.forms.yes_no[0]
                };
                let loadingObj = {
                    color: '',
                    value: 2,
                    text: allLangFiles.forms.loading
                };
                let selected = noObj;

                if (data == 1) {
                    selected = yesObj;
                } else if (data == 2) {
                    selected = loadingObj;
                }
                return `
                    <div class="dropdown">
                        <button class="btn btn-primary btn-raised dropdown-toggle employee_field_button ${selected.color}" data-color="${selected.color}" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">${selected.text}<div class="ripple-container"></div></button>
                        <div class="dropdown-menu dropdown-menu-center">
                            <a class="dropdown-item select_reload_on_demand" href="#" data-value="${noObj.value}" data-id="${row.id}" data-color="${noObj.color}">${noObj.text}</a>
                            <a class="dropdown-item select_reload_on_demand" href="#" data-value="${yesObj.value}" data-id="${row.id}" data-color="${yesObj.color}">${yesObj.text}</a>
                            <a class="dropdown-item select_reload_on_demand" href="#" data-value="${loadingObj.value}" data-id="${row.id}" data-color="${loadingObj.color}">${loadingObj.text}</a>
                        </div>
                    </div>`;
            },
        },
        {data: 'services.reload_on_demand'}

    ];

    /*Rules for filling the columns*/
    var columnDefs = [
        //Main
        {visible: false, targets: 0},
        {visible: true, targets: 1, width: "35%"},

        //Status
        {className: "dt-left", visible: true, targets: 2},
        {className: "text-center", visible: true, targets: 3},
        {className: "text-center", visible: false, targets: 4},
        {className: "text-center", visible: true, targets: 5},
        {className: "text-center", visible: true, targets: 6},
        {className: "text-center", visible: false, targets: 7},
        {className: "text-center", visible: true, targets: 8},
        {className: "text-center", visible: true, targets: 9},

        //Vat
        {className: "text-center", visible: false, targets: 10},
        {className: "text-center", visible: true, targets: 11},
        //End Vat

        {className: "text-center", visible: true, targets: 12},

        //Salary
        {className: "text-center", visible: true, targets: 13},
        //End Salary

        //Deadlines
        {className: "text-center", visible: true, targets: 14},
        {className: "text-center", visible: true, targets: 15},
        {className: "text-center", visible: true, targets: 16},
        {className: "text-center", visible: true, targets: 17},
        {className: "text-center", visible: true, targets: 18, orderData: 19},
        //End deadlines

        //Vouchers
        {className: "text-center", visible: true, targets: 20},

        //reload on demand
        {className: "text-center", visible: true, targets: 21, width: '10%', orderData: 22},
        {className: "text-center", visible: false, targets: 22},
    ];


    /*Important otherwise table misaligned*/
    $(tableName).css('width', '100%');


    var table = $(tableName).DataTable({

        language: allLangFiles.datatables,

        rowId: 'id',
        ajax: {
            url: '/dashboard/admin/v2/all/' + reportingPeriod + '/' + companyGroupingVal,
            dataSrc: function (json) {

                return json.data;
            },
        },
        fixedColumns: {
            leftColumns: 2,
            heightMatch: 'none'
        },
        columns: columns,
        columnDefs: columnDefs,
        order: [[1, "asc"]],
        scrollX: true,
        orderCellsTop: true,
        lengthMenu: [[-1, 10, 25, 50, 75, 100], [allLangFiles.datatables.all, 10, 25, 50, 75, 100]],
        initComplete: function (settings, json) {
        },
        drawCallback: function (settings) {
            if (table) {
                var info = table.page.info();
                var count = info.recordsTotal;
                $('#entries').text('Entries:  ' + count);
            }
            var api = this.api();

            /* Apply the tooltips */
            $('td > div.company-tooltips', api.table().container()).tooltip({
                container: 'body',
                show: {delay: 250, duration: 0},
                tooltipClass: "custom-tooltip",
            });
        },
    });

    addExpandableColumnListener(tableName, table);
    addTopSearchColumn(tableName, table);
    addDashboardExportBtns(table);

    function addDashboardExportBtns(table) {
        var exportColumns = [0, 1, 2, 4, 5, 7, 8, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19]; //Remember to change this if adding column
        var title = 'dashboard_' + moment().format("YYYY-MM-DD");
        new $.fn.dataTable.Buttons(table, {
                buttons: [
                    {
                        extend: 'excel',
                        exportOptions: {
                            columns: exportColumns
                        },
                        title: title
                    },
                    {
                        extend: 'pdf',
                        exportOptions: {
                            columns: exportColumns
                        },
                        title: title
                    },
                    {
                        extend: 'csv',
                        exportOptions: {
                            columns: exportColumns
                        },
                        title: title
                    },
                    {
                        extend: 'copy',
                        exportOptions: {
                            columns: exportColumns
                        },
                        title: title
                    },
                    {
                        extend: 'print',
                        exportOptions: {
                            columns: exportColumns
                        },
                        title: title
                    },
                ]
            }
        );
        addButtonStyling(table);
    }
};